module.exports = __webpack_public_path__ + "img/DE05694.765bde1b.png";